<template>
	<div id="uCenterNav">
		<div class="u_c_M_LeftNav">
			<ul class="u_c_M_LN_ul">
				<li class="u_c_M_LN_u_li" v-for="(item,n) in navList" :key="n">
					<router-link :to="item.path">
						<Icon :custom="item.icon" size="18" />
						<span class="u_c_M_LN_u_liName">{{item.name}}</span>
						<span class="u_c_M_LN_u_liArrow">
							<Icon type="ios-arrow-forward" />
						</span>
					</router-link>
				</li>
				<!-- <li class="u_c_M_LN_u_li outLogin">
					<Button type="error" icon="ios-log-out" ghost>退出登录</Button>
				</li> -->
			</ul>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'uCenterNav',
		data() {
			return {
				navList: [{
					name: '我的',
					path: '/userCenter/my',
					icon: 'iconfont icon-me'
				}, {
					name: '视频',
					path: '/userCenter/collect',
					icon: 'iconfont icon-collects'
				}, {
					name: '直播预约',
					path: '/userCenter/live',
					icon: 'iconfont icon-yy'
				}, {
					name: '知识库',
					path: '/userCenter/knowledge',
					icon: 'iconfont icon-know'
				}, 
				// {
				// 	name: '学习计划',
				// 	path: '/userCenter/study',
				// 	icon: 'iconfont icon-study'
				// }, 
				{
					name: '用户设置',
					path: '/userCenter/set',
					icon: 'iconfont icon-set'
				}]
			}
		}
	}
</script>

<style>
	.u_c_M_LeftNav {
		height: 100%;
		width: 100%;
		background: url(../../assets/img/uc_nav.png);
		background-size: 100% 100%
	}

	.u_c_M_LN_ul {
		font-size: 16px;
		color: #333333;
		/* padding: 20px 0; */
	}

	.u_c_M_LN_u_li {
		line-height: 46px;
		position: relative;
		width: 100%;
	}

	.u_c_M_LN_u_li a {
		display: block;
		padding: 0 20px;
		width: 100%;
		color: #333333;
	}

	.u_c_M_LN_u_li a:hover {
		color: #115467;
		font-weight: bold;
		background: rgba(255,255,255,.6);
	}

	.u_c_M_LN_u_liName {
		margin-left: 20px;
	}

	.u_c_M_LN_u_liArrow {
		position: absolute;
		right: 20px;

	}

	.outLogin {
		text-align: center;
		margin-top: 20px;
	}
</style>
